<template>
	<div class = 'form container'>
		<div>
			<div class = 'panel'>
				<form @submit.stop = 'createNewVoc'>
					<div class = 'form-group'>
						<label for= 'language' class="form-label">Langue</label>
						<select class = 'form-control' v-model='language' id = 'language' name = 'language'>
							<option value = 'english'>Anglais</option>
							<option value = 'deutsch'>Allemand</option>
						</select>
					</div>
					<div class = 'form-group'>
						<label for = 'name'>Titre du voc</label>
						<input type = 'text' name = 'name' placeholder = 'titre du voc...' class = 'form-control' v-model="name">
					</div>
					<div class = 'form-group'>
						<label for = 'voc'>Les mots</label>
						<textarea cols= '80' rows="20" type = 'text' name = 'voc' placeholder = 'les mots du voc' class = 'form-control' v-model="words" />
					</div>
					<div class = 'form-group'>
						<button type = 'submit' class = 'btn btn-primary' :disabled="!name || !words">enregistrer</button>
						<button type = 'button' class = "btn btn-danger" @click="deleteVoc">{{(confirm)?"confirmer":"effacer"}}</button>
						<button type = 'button' class = "btn btn-secondary" v-if = "confirm" @click="confirm=false">annuler</button>
						<router-link to="/" class="btn btn-default ml-3" v-if="!confirm">annuler</router-link>
					</div>
				</form>
			</div>
		</div>
		
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
	name: 'editVoc',
	data () {
		return {
			confirm: false,
			name: '',
			language: 'english',
			words: '',
			terms: []
		}
	},
	computed: {
		...mapGetters({
			vocs: 'vocs'
		})
	},
	methods: {
		createNewVoc (evt) {
			let vm = this
			evt.preventDefault();
			let pairs = this.words.trim().split("\n");
			let left;
			_.forEach(pairs, p => {
				let pair = p.trim().split(/[\t]/)
				if (pair.length == 2) {
					this.terms.push(pair)	
				} 
				else if (pair.length == 4){
					this.terms.push([pair[0],pair[1]])	
					this.terms.push([pair[2],pair[3]])	
				}
				else if (pair.length == 3 && this.language === 'deutsch'){
					left = pair[0];
					if (pair[1]) left += " / "+pair[1];
					this.terms.push([left,pair[2]])	
				}
			})
			if (this.terms.length){
				this.$store.dispatch("setVoc",{
					name: this.name,
					language: this.language,
					terms: this.terms
				}).then(res => {
					vm.$router.push('/')
				})
			}
		},
		deleteVoc (){
			if (!this.confirm) this.confirm = true;
			else {
				this.$store.commit('DELETE_VOC',{
					name: this.name,
					language: this.language
				})
				this.$router.push('/')
			}
		}
	},
	mounted () {
		let vocname = this.$route.params.voc
		if (vocname.substr(0,4) !== 'new_'){
			let voc = _.filter(this.vocs,v => v.name === vocname)[0];
			this.name = voc.name
			this.language = voc.language
			this.words = _.map(voc.terms,t => t.join('\t')).join("\n")
		}
		else this.language = vocname.substr(4)
	}
	
}

</script>